import React from 'react';

interface SaveSpinnerProps {
  width?: string | number;
  height?: string | number;
  color?: string;
  className?: string;
  spinning?: boolean;
}

export const SaveSpinner: React.FC<SaveSpinnerProps> = ({
  width = 24,
  height = 24,
  color = 'currentColor',
  className,
  spinning = true,
}) => {
  const outerPathStyle: React.CSSProperties = {
    transformOrigin: '12px 12px',
    animation: spinning ? 'saveSpinnerOuter 1.5s linear infinite' : 'none',
  };

  const innerPathStyle: React.CSSProperties = {
    transformOrigin: '12px 12px',
    animation: spinning ? 'saveSpinnerInner 1.2s linear infinite reverse' : 'none',
  };

  return (
    <>
      <style>
        {`
          @keyframes saveSpinnerOuter {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @keyframes saveSpinnerInner {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g clipPath="url(#saveSpinnerClip)">
          {/* Outer rotating arc */}
          <path
            d="M4.92893 19.0711C3.53041 17.6725 2.578 15.8907 2.19215 13.9509C1.80629 12.0111 2.00433 10.0004 2.7612 8.17317C3.51808 6.3459 4.79981 4.78412 6.4443 3.6853C8.08879 2.58649 10.0222 2 12 2C13.9778 2 15.9112 2.58649 17.5557 3.6853C19.2002 4.78412 20.4819 6.34591 21.2388 8.17317C21.9957 10.0004 22.1937 12.0111 21.8079 13.9509C21.422 15.8907 20.4696 17.6725 19.0711 19.0711"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={outerPathStyle}
          />
          {/* Inner rotating arc */}
          <path
            d="M16.2426 7.75736C17.0818 8.59647 17.6532 9.66557 17.8847 10.8295C18.1162 11.9933 17.9974 13.1997 17.5433 14.2961C17.0892 15.3925 16.3201 16.3295 15.3334 16.9888C14.3467 17.6481 13.1867 18 12 18C10.8133 18 9.65327 17.6481 8.66658 16.9888C7.67988 16.3295 6.91085 15.3925 6.45672 14.2961C6.0026 13.1997 5.88378 11.9933 6.11529 10.8295C6.3468 9.66557 6.91825 8.59647 7.75736 7.75736"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={innerPathStyle}
          />
        </g>
        <defs>
          <clipPath id="saveSpinnerClip">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </>
  );
};